<template>
  <div v-cloak>
    <van-pull-refresh v-model="is_refresh" @refresh="onRefresh" style="margin-bottom: 50px">
      <van-search v-model="select_value" placeholder="请输入搜索关键词" :clearable="true" @search="do_search" @clear="do_clear"></van-search>
      <van-swipe class="my-swipe" :autoplay="3000" indicator-color="white" height="150">
        <van-swipe-item class="weball-font-20" v-for="(item, index) in banners" :key="index" @click="go_banner(item)">
          <van-image class="swipe-img" lazy-load :src="item.res_img.web_path" fit="cover"></van-image>
        </van-swipe-item>
      </van-swipe>
      <van-list v-model="is_loading"
                :finished="is_load_finished"
                :immediate-check="false"
                finished-text="没有更多了"
                :error.sync="is_error"
                error-text="请求失败，点击重新加载"
                @load="onLoad">
        <van-cell :title="'最新分析'"  value=""></van-cell>
        <project-item :project="{
            articles:item.articles,
            project_id:item.project_id,
            is_multi:item.articles.length>1,
            avatar:item.articles[0].article.writer.avatar.web_path,
            category:item.project_category,
            title:item.project_title,
            content_visible:item.articles[0].article.article_content_visible,
            price:item.project_price,
            borwser_num:item.project_borwser_num,
            state:item.project_state,
            project_label:item.project_label
          }" v-for="(item, index) in list" :key="index">
        </project-item>

      </van-list>
    </van-pull-refresh>
    <van-tabbar @change="" route>
      <van-tabbar-item icon="home-o" replace :to="werouter.index.path">首页</van-tabbar-item>
      <van-tabbar-item icon="hot-o" replace :to="werouter.author.path">大神</van-tabbar-item>
      <van-tabbar-item icon="medal-o" replace :to="werouter.match.path">赛事</van-tabbar-item>
      <van-tabbar-item icon="chat-o" replace :to="werouter.message.path">消息</van-tabbar-item>
      <van-tabbar-item icon="user-circle-o" replace :to="werouter.mine.path">我的</van-tabbar-item>
    </van-tabbar>
  </div>
</template>

<script>
    import avatar_group from '@/assets/avatar_group.png'
    import game_over from '@/assets/game_over.png'
    import ProjectItem from '@/views/components/ProjectItem'
    export default {
        name: 'index',
        components:{
          ProjectItem
        },
        data() {
            return {
                images:{
                    avatar_group:avatar_group,
                    game_over:game_over
                },
                select_value: '',
                banners: [],
                page: 0,
                list: [],
                is_error: false,
                is_refresh: false,
                is_loading: false,
                is_load_finished: false,
                is_cancel:false
            }
        },
        created: function () {
          {
            this.getBanners();
            this.page = 1;
            this.getData(this.page, false)
          }
        },
        mounted:function(){
        },
        methods: {
            onRefresh() {
                this.getBanners();
                this.select_value = '';
                this.page = 1;
                this.is_load_finished = false;
                this.getData(this.page, true)
            },
            onLoad() {
                this.page++;
                this.getData(this.page, false);
            },
            go_banner:function(banner){
                window.location.href = banner.path
            },
            getData: function (page, refresh) {
                let that = this;
                this.weapi.request({
                    url: 'project_list',
                    method: 'get',
                    params: {page:page,select:this.select_value},
                }).then(res => {
                    if (res.data.code === '200') {
                        let _list = res.data.data.list;
                        if (refresh) {
                            that.list = [];
                            that.$toast('刷新成功！');
                            that.is_refresh = false;
                        }
                        if (that.page <= 1) {
                            that.list = [];
                        }
                        for (let i = 0; i < _list.length; i++) {
                            that.list.push(_list[i]);
                        }
                        if (res.data.data.end) {
                            that.is_load_finished = true;
                        }
                    }
                    else {
                        that.is_refresh = false;
                        that.is_error = true;
                    }
                }).catch(function (error) {
                    that.$toast('系统错误，请稍后重试！');
                    that.is_refresh = false;
                    that.is_error = true;
                }).finally(function (response) {
                    that.is_loading = false;
                })
            },
            getBanners: function () {
                let that = this;
                this.weapi.request({
                    url: 'banners',
                    method: 'get',
                    params: {},
                }).then(res => {
                    if (res.data.code === '200') {
                        that.banners = res.data.data
                    }
                    else {
                        that.$toast('系统错误，请稍后重试！');
                        // that.$toast(res.data.message);
                    }
                }).catch(function (error) {
                    that.$toast('系统错误，请稍后重试！');
                }).finally(function (response) {
                })
            },
            do_search:function(value){
                this.is_load_finished = false;
                this.page = 1;
                this.getData(this.page = 1, false);
            },
            do_clear:function(res){

            },
        }
    }
</script>
<style>

  .my-swipe .van-swipe-item {
    color: #fff;
    line-height: 160px;
    text-align: center;
    background-color: #39a9ed;
  }

  .my-swipe .swipe-img {
    width: 100%;
  }
  .article-content-wrap{
    position: relative;
    margin-left: 10px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: flex-start;
    height: 100%;
  }
  .tongji-wrap{
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    margin-right: 20px;
  }
  .tongji-wrap span{
    margin-left: 5px;
  }
  /*.van-list{*/
    /*margin:10px;*/
    /*border-radius: 4px;*/
  /*}*/
</style>
